import { AudioManager, AudioType } from '@colonist/audio';
import { UIChatPostController } from './UIChatPostController.ts';
export class UIChatPost {
    static post(container, chatData, preventScroll = false, makeSound = true) {
        const postController = new UIChatPostController(container, chatData);
        if (makeSound) AudioManager.play(AudioType.MessageNotification);
        if (!preventScroll) container.scrollTop = container.scrollHeight;
        return postController.post;
    }
}
